import { Injectable } from '@angular/core';
import { DragNotificationService } from './core.drag-notification.service';

@Injectable()
export class AppInitializationService {
    constructor(private dragNotificationService: DragNotificationService) {}

    /**
     * Initialize core application services
     */
    initializeApp(): void {
        this.dragNotificationService.initializeDragListeners();
    }
}
